import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { MessageList, ChatInput, DocumentContext } from '../components';
import { colors, fontSizes, fontWeights } from '../theme/theme';

const ChatView = () => {
  const error = useSelector(state => state.chat.error);
  const containerRef = useRef(null);

  const containerStyle = {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    background: colors.background,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  };

  const contentStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  };

  const errorStyle = {
    padding: '16px 20px',
    margin: '16px 20px',
    background: `rgba(211, 47, 47, 0.1)`,
    border: `1px solid rgba(211, 47, 47, 0.2)`,
    borderRadius: '8px',
    color: colors.error,
    fontSize: fontSizes.caption,
  };

  return (
    <div style={containerStyle} ref={containerRef}>
      {/* Document Context */}
      <DocumentContext />
      
      {/* Content */}
      <div style={contentStyle}>
        {error && <div style={errorStyle}>❌ {error}</div>}
        <MessageList />
        <ChatInput />
      </div>
    </div>
  );
};

export default ChatView; 